import { Controller } from '@hotwired/stimulus'

const scrollPositions: Map<string, number> = new Map()

export default class extends Controller {
  connect (): void {
    if (this.element.id === '') return

    const el = this.element as HTMLElement
    this.restoreScroll(el)
    el.addEventListener('scroll', this.trackScroll, { passive: true })
  }

  disconnect (): void {
    this.element.removeEventListener('scroll', this.trackScroll)
  }

  private restoreScroll (el: HTMLElement): void {
    const saved = scrollPositions.get(this.element.id)
    if (saved === undefined || saved <= 0) return

    void el.offsetWidth
    el.scrollLeft = saved
    scrollPositions.delete(this.element.id)

    this.ensureSortedColumnVisible(el)
  }

  private ensureSortedColumnVisible (el: HTMLElement): void {
    const sorted = el.querySelector<HTMLElement>('.is-selected')
    if (sorted === null) return

    const th = sorted.closest('th')
    if (th === null) return

    const containerRect = el.getBoundingClientRect()
    const thRect = th.getBoundingClientRect()

    if (thRect.right > containerRect.right) {
      el.scrollLeft += thRect.right - containerRect.right
    } else if (thRect.left < containerRect.left) {
      el.scrollLeft -= containerRect.left - thRect.left
    }
  }

  private readonly trackScroll = (): void => {
    if (this.element.id !== '') {
      scrollPositions.set(this.element.id, (this.element as HTMLElement).scrollLeft)
    }
  }
}
